module.exports = __webpack_public_path__ + "img/products.7bb0182f.svg";